import MuiTableCell from "@mui/material/TableCell";

export default function TableCell(props) {
  const { children, ...rest } = props;
  return (
    <MuiTableCell {...rest}>
      <span>{children}</span>
    </MuiTableCell>
  );
}
